export const CHEST_COUNT = 36;
export const MAX_ATTEMPTS = CHEST_COUNT / 2;
export const DANGER_ATTEMPTS = 5;

export const GameStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  DEFEAT: 'DEFEAT',
  VICTORY: 'VICTORY',
};

export const GameEndPhrases = {
  [GameStatus.DEFEAT]: 'You lose!',
  [GameStatus.VICTORY]: 'You found it!',
};
